import {
    clearShopProfile,
    didReceiveShopProfessionals, didReceiveShops, invalidateShops, requestFailed, requestShopProfessionals,
    requestStarted,
    requestSucceeded
} from "./actions";
import ShopRepository from "../_repositories/shopRepository";
import {plainToClass} from "class-transformer";
import Meta from "../_data/models/Meta";
import {getCurrentUser} from "../_helpers/utils";
import {addDataAction, updateDataAction} from "../_data/actions";
import {ResourceType} from "../_helpers/data";
import Shop from "../_data/models/Shop";
import * as _ from "lodash";
import {Map} from "immutable";
import {fetchBoothsByShop} from "../booth/middlewares";

export function refreshShops() {
    return (dispatch) => {
        dispatch(invalidateShops());
        return dispatch(fetchShops());
    }
}

export function initializeShopProfile(shopId: number) {
    return (dispatch) => {
        dispatch(fetchBoothsByShop(shopId));
        dispatch(fetchShopProfessionals(shopId));

        return dispatch(clearShopProfile());
    }
}

export function fetchShops(cursor: number = null, page: number = null) {
    return (dispatch) => {
        dispatch(requestStarted());
        ShopRepository.listByUser(getCurrentUser(), cursor, page, 25)
            .then(data => {
                const {salons, meta} = data;
                // Todo: handle errors
                if (data.error) {
                    return dispatch(requestFailed({requestErrors: ["Failed to retrieve salons."]}));
                }
                let shopIds = _.map(salons, (each) => {
                    return [each["id"], parseInt(each["id"])];
                });
                dispatch(addDataAction({
                    resource: ResourceType.shop,
                    data: salons
                }));

                dispatch(didReceiveShops({
                    ids: Map<number, number>(shopIds),
                    meta: plainToClass(Meta, meta),
                }));

                return dispatch(requestSucceeded());
        });
    }
}

export function fetchShopProfessionals(shopId: number, cursor: number = null, page: number = null) {
    return (dispatch) => {

        dispatch(requestShopProfessionals());
        ShopRepository.getShopProfessionals(shopId, cursor, page, 25)
            .then((data) => {
                const {professionals, meta} = data;

                let userIds = _.map(professionals, (each) => {
                    return [each["id"], parseInt(each["id"])];
                });

                dispatch(addDataAction({
                    resource: ResourceType.user,
                    data: professionals
                }));

                return dispatch(didReceiveShopProfessionals({
                    ids: Map<number,number>(userIds),
                    meta: plainToClass(Meta, meta)
                }));
            });

    }
}


// WEBPACK FOOTER //
// ./app/client/shop/middlewares.ts